import React from 'react'
import { useEffect, useState } from 'react'
import axios from '~/data/http/axios'
import rawAxios from 'axios'
import AutoComplete from '~/Common-Objects/AutoComplete'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Modal from '~/Common-Objects/Modal/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import ProgressNav from '~/Common-Objects/Navigation/ProgressNav'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { useSelector, useDispatch } from 'react-redux'
import TranspondSiteTracking from '~/Classes/siteTrackingHelpers'
import i18n from '~/i18n'
import postHogFunctions from '~/Classes/posthog'
import Industries from '~/Classes/industries'
import moment from 'moment'
import MoreQuestions from './moreQuestions'
import helpers from '~/Classes/helpers'

const contactBands = [
    { label: '0-1000', value: '0-1000' },
    { label: '1,000-5,000', value: '1000-5000' },
    { label: '5,000-10,000', value: '5000-10000' },
    { label: '10,000-20,000', value: '10000-20000' },
    { label: '20,000-50,000', value: '20000-50000' },
    { label: '50,000-100,000', value: '50000-100000' },
    { label: '100,000-200,000', value: '100000-200000' },
    { label: '200,000+', value: '200000+' }
]

export default function NewUserForm({ from = '', finish = () => {} }) {
    const account = useSelector((state) => state.accountMaster)
    const user = useSelector((state) => state.user)
    const site = useSelector((state) => state.siteMaster)

    const [loading, setLoading] = useState(true)
    const [adminRequired, setAdminRequired] = useState(false)

    const [formCompleteStatus, setFormCompleteStatus] = useState(0)
    const [accountMaster, setAccountMaster] = useState(null)
    const [countryData, setCountryData] = useState([])
    const [hasVatError, setHasVatError] = useState(false)
    const [selectedAddress, setSelectedAddress] = useState(false)
    const [isCapsule, setIsCapsule] = useState(false)
    const [approvalTakingTooLong, setApprovalTakingTooLong] = useState(0)
    const [checkingStep2, setCheckingStep2] = useState(false)

    const [errors, setErrors] = useState({
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        accountType: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        county: '',
        country: '',
        postCode: '',
        vatNumber: '',
        addressLookup: ''
    })
    const [answers, setAnswers] = useState({
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        accountType: '',
        address1: account.accountMaster.address1 || '',
        address2: account.accountMaster.address2 || '',
        address3: account.accountMaster.address3 || '',
        city: account.accountMaster.city || '',
        county: account.accountMaster.county || '',
        country: account.accountMaster.country || '',
        postCode: account.accountMaster.postCode || '',
        vatNumber: '',
        companyId: '',
        addressLookup: ''
    })

    useEffect(() => {
        startup()
    }, [])

    const startup = async () => {
        if (user.userData.roleId !== 1) {
            setAdminRequired(true)
            return
        }
        const accMaster = await axios.get('/accountMaster')
        setAccountMaster(accMaster.data.AccountMaster)
        if (accMaster.data.AccountMaster.doneNewUserQuestions) {
            if (accMaster.data.AccountMaster.approved) {
                setFormCompleteStatus(3)
            } else {
                setFormCompleteStatus(4)
            }
            setLoading(false)
            return
        }

        postHogFunctions.capture('questionnaire_started')
        TranspondSiteTracking.pageChange(user.userData.emailAddress, { 'popup.questions': true })

        let countryDat = await axios.get('/countries')
        countryDat = countryDat.data
        countryDat = countryDat.Countries.map((thisLine) => ({
            label: thisLine.name,
            value: thisLine.name,
            currency: thisLine.currency,
            code: thisLine.code,
            isEU: thisLine.isEU
        }))
        setCountryData(countryDat)

        let apps = await axios.get('/accountMaster/application')
        apps = apps.data.Applications

        let isCapsule = apps.find((a) => a.ApplicationId === 8)
        if (isCapsule) isCapsule = true
        setIsCapsule(isCapsule)

        if (!answers.country) {
            await getLocation()
        }
        setLoading(false)
    }

    const getLocation = async () => {
        let response = await rawAxios({
            url: 'https://ipinfo.io?token=c4ac161f272f10',
            json: true
        })
        const country = countryData.find((c) => c.code === response.data.country)
        if (!country) return
        const answers = { ...answers }
        answers.country = country.value
        setAnswers(answers)
    }

    const updateVal = async (event) => {
        let theVal = event.target.value
        let theName = event.target.name
        let answersTmp = { ...answers }
        answersTmp[theName] = theVal
        setAnswers(answersTmp)
    }

    const checkFormStep1 = async () => {
        let tmpErrors = { question1: '', question2: '', question3: '', question4: '', question5: '' }
        let formStatus = 1
        if (
            !isCapsule &&
            (answers.question1 === undefined || answers.question1 === '' || answers.question1.length < 2)
        ) {
            tmpErrors.question1 = 'Please enter a longer answer'
            formStatus = 0
        }
        if (!accountMaster.newUserHowManySubs && (answers.question2 === undefined || !answers.question2.trim())) {
            tmpErrors.question2 = 'Please select a contact band'
            formStatus = 0
        }
        if (answers.question3 === undefined || answers.question3 === '' || answers.question3.length < 2) {
            tmpErrors.question3 = 'Please enter a longer answer'
            formStatus = 0
        }

        let question4Final = answers.question4.trim()

        let isValidWebsite = true
        if (
            question4Final.indexOf(' ') > -1 ||
            question4Final.indexOf('.') < 0 ||
            question4Final.indexOf(',') > -1 ||
            question4Final.indexOf(';') > -1
        ) {
            isValidWebsite = false
        }

        if (question4Final === undefined || question4Final === '' || question4Final.length < 2 || !isValidWebsite) {
            tmpErrors.question4 = 'Please enter a valid website address'
            formStatus = 0
        }
        if (answers.question5 === undefined || answers.question5 === '' || answers.question5.length < 2) {
            tmpErrors.question5 = 'Please select a business type'
            formStatus = 0
        }

        setErrors(tmpErrors)
        setFormCompleteStatus(formStatus)
    }

    const checkFormStep2 = async () => {
        setHasVatError(false)
        setCheckingStep2(true)
        let tmpErrors = { address1: '', address2: '', address3: '', city: '', county: '', country: '', postCode: '' }

        let hasError = false
        if (answers.address1 === undefined || answers.address1 === '' || answers.address1.length < 1) {
            tmpErrors.address1 = 'Please enter a longer address'
            hasError = true
        }
        if (answers.city === undefined || answers.city === '' || answers.city.length < 1) {
            tmpErrors.city = 'Please enter a longer city'
            hasError = true
        }
        if (!answers.country || answers.country.length < 1) {
            tmpErrors.country = 'Please select a country'
            hasError = true
        }
        if (answers.postCode === undefined || answers.postCode === '' || answers.postCode.length < 1) {
            tmpErrors.postCode =
                answers.country === 'United Kingdom'
                    ? i18n.t('company:my.postCodeError')
                    : i18n.t('company:my.zipError')
            hasError = true
        }

        setErrors(tmpErrors)
        if (hasError) {
            setCheckingStep2(false)
            return
        }

        const country = countryData.find((c) => c.value === answers.country)
        let currency = 'USD'
        let isEU = false
        if (!country) {
            setErrors({ country: 'Invalid country' })
            setCheckingStep2(false)
            return
        }
        if (country && country.currency) {
            currency = country.currency
            isEU = country.isEU
        }

        if (isEU) {
            const vatCheckResult = await axios.post('/accountMaster/checkVat', {
                country: country.code,
                vatNumber: answers.vatNumber
            })

            if (!vatCheckResult.data.valid) {
                if (!answers.noVatReason) {
                    if (isEU) {
                        setErrors({ vatNumber: 'Invalid VAT number', noVatReason: 'Please provide a reason' })
                        setHasVatError(true)
                    } else {
                        setHasVatError(false)
                        setErrors({ vatNumber: 'Invalid VAT number' })
                    }
                    setCheckingStep2(false)
                    return
                }
            }
        }

        const data = {
            accountName: account.accountMaster.accountName,
            doneNewUserQuestions: true,
            newUserHowDidYouHear: answers.question1,
            newUserHowManySubs: accountMaster.newUserHowDidYouHear || answers.question2,
            newUserObtainSubscribers: answers.question3,
            newUserWebsiteAddress: answers.question4,
            industry: answers.question5,
            address1: answers.address1,
            address2: answers.address2,
            address3: answers.address3,
            city: answers.city,
            county: answers.county,
            postCode: answers.postCode,
            currency,
            vatNumber: answers.vatNumber,
            country: answers.country,
            isEU: isEU,
            from: from,
            noVarReason: answers.noVatReason
        }

        postHogFunctions.capture('questionnaire_completed')
        await axios.put('/accountMaster', data)
        TranspondSiteTracking.pageChange(user.userData.emailAddress, { 'popup.questionsDone': true })
        setCheckingStep2(false)
        startAutoApproval()
    }

    const startAutoApproval = async () => {
        setFormCompleteStatus(2)
        let secondsSinceStart = 0
        let approvalStartTime = moment().utc().format('HH-mm-ss')
        let finalStatus = null

        while (secondsSinceStart < 60) {
            let approvalResponse = await axios
                .get(`/accountMaster/approval?startTime=${approvalStartTime}`)
                .catch((err) => {})
            if (approvalResponse?.data?.approved !== null) {
                finalStatus = approvalResponse.data.approved ? 'approved' : 'rejected'
                setFormCompleteStatus(approvalResponse.data.approved ? 3 : 5)
                return
            }
            await new Promise((r) => setTimeout(r, 1000))
            secondsSinceStart++
            if (secondsSinceStart >= 15 && !approvalTakingTooLong) {
                setApprovalTakingTooLong(1)
            }
        }

        if (finalStatus) {
            postHogFunctions.capture('questionnaire_completed', { status: finalStatus })
        }
        setFormCompleteStatus(4)
    }

    const changeAddress = async (selected) => {
        try {
            let placeId = selected.value
            let resp = await axios.get('/accountMaster/addresslookupindepth?placeid=' + placeId)
            let tmpAnswers = { ...answers }
            tmpAnswers.address1 = resp.data.houseNo
            tmpAnswers.address2 = resp.data.street1
            tmpAnswers.address3 = resp.data.street2
            tmpAnswers.city = resp.data.town
            tmpAnswers.county = resp.data.county
            tmpAnswers.country = resp.data.country
            tmpAnswers.postCode = resp.data.postCode

            let tmpErrors = { ...errors }
            tmpErrors.address1 = ''
            tmpErrors.address2 = ''
            tmpErrors.address3 = ''
            tmpErrors.city = ''
            tmpErrors.county = ''
            tmpErrors.country = ''
            tmpErrors.postCode = ''
            tmpErrors.vatNumber = ''

            setAnswers(tmpAnswers)
            setErrors(tmpErrors)
            setSelectedAddress(true)
        } catch (err) {}
    }

    const onFinish = async () => {
        await helpers.skipApprovalAnalysis()
        finish()
    }

    if (adminRequired) {
        return (
            <Modal blurBg={true} width={500} closeButton={true} onCloseButton={finish}>
                <div className='newUserFormOuterContentHolder'>
                    <div className='newUserFormInnerContentHolder'>
                        <h3 className='mar-b15 text-center'>Admin Required</h3>
                        <div className='text-center'>
                            You are not authorized to complete the approval process. Please contact an administrator to
                            gain access.
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    if (loading || !accountMaster) return <></>

    const steps = [
        {
            title: 'About You',
            onClick: () => {
                if (formCompleteStatus === 1) {
                    setFormCompleteStatus(0)
                }
            },
            selected: formCompleteStatus === 0,
            complete: formCompleteStatus > 0
        },
        {
            title: 'Your Business',
            selected: formCompleteStatus === 1,
            complete: formCompleteStatus >= 2
        },
        {
            title: formCompleteStatus === 5 ? 'Verify' : 'Confirmation',
            onClick: () => {},
            selected:
                formCompleteStatus === 2 ||
                formCompleteStatus === 3 ||
                formCompleteStatus === 4 ||
                formCompleteStatus === 5,
            complete: formCompleteStatus === 3
        }
    ]

    const country = countryData.find((c) => c.value === answers.country)
    const isEU = country && country.isEU

    let info = 'send your first campaign'
    if (from === 'automation') {
        info = 'start automations'
    }
    if (from === 'email') {
        info = 'send your first email'
    }
    if (from === 'tracking') {
        info = 'start tracking your first site'
    }
    if (from === 'form') {
        info = 'deploy your first form'
    }
    if (from === 'payment') {
        info = 'make your first payment'
    }
    if (from === 'account') {
        info = 'change your email address'
    }
    if (from === 'clean') {
        info = 'start a list clean'
    }
    if (from === 'labs') {
        info = 'start using the new features'
    }

    return (
        <>
            <Modal
                width='90%'
                height='90%'
                noClickAway={true}
                blurBg={true}
                top={false}
                closeButton={formCompleteStatus != 2}
                onCloseButton={onFinish}
            >
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '100%' }}>
                    <div className='newUserFormOuterContentHolder'>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                            className='mar-b25'
                        >
                            <h2 className='mar-b15 text-center'>Help Us Verify Your Account</h2>
                            <div className='mar-b30 text-center'>
                                Before you can {info}, please tell us a little bit about yourself.
                            </div>
                            <div>
                                <ProgressNav steps={steps} />
                            </div>
                        </div>

                        <div style={{ height: '100%' }}>
                            {formCompleteStatus === 0 && (
                                <div className='newUserFormInnerContentHolder'>
                                    <Row>
                                        {!accountMaster.newUserHowManySubs && (
                                            <Column xs={12}>
                                                <Select
                                                    data={contactBands}
                                                    outerClassName='mar-b20'
                                                    label='How many marketing contacts do you currently have?'
                                                    name='question2'
                                                    value={answers.question2}
                                                    error={errors.question2}
                                                    onChange={updateVal}
                                                />
                                            </Column>
                                        )}
                                        <Column xs={12}>
                                            <Select
                                                filter={true}
                                                data={Industries.industryArray()}
                                                outerClassName='mar-b20'
                                                label='What type of business best describes you?'
                                                name='question5'
                                                value={answers.question5}
                                                placeholder='Select a business type'
                                                error={errors.question5}
                                                onChange={updateVal}
                                            />
                                        </Column>

                                        <Column xs={12}>
                                            <TextInput
                                                outerClassName='mar-b20'
                                                type='url'
                                                label='What is your website address?'
                                                name='question4'
                                                value={answers.question4}
                                                placeholder='http://'
                                                error={errors.question4}
                                                onChange={updateVal}
                                            />
                                        </Column>

                                        {!isCapsule && (
                                            <Column xs={12}>
                                                <TextInput
                                                    outerClassName='mar-b20'
                                                    label={`How did you hear about ${site.siteName}`}
                                                    name='question1'
                                                    value={answers.question1}
                                                    error={errors.question1}
                                                    onChange={updateVal}
                                                />
                                            </Column>
                                        )}

                                        <Column xs={12}>
                                            <TextInput
                                                outerClassName='mar-b20'
                                                label='How do you collect or acquire your contacts?'
                                                explainer='For example: website signups, event attendees, purchased lists, referrals, etc. '
                                                name='question3'
                                                value={answers.question3}
                                                error={errors.question3}
                                                onChange={updateVal}
                                            />
                                        </Column>

                                        <Column xs={12}>
                                            <Button
                                                className='button-primary'
                                                iconRight={<Icons icon='arrowRight' />}
                                                text='Continue'
                                                onClick={checkFormStep1}
                                            />
                                        </Column>
                                    </Row>
                                </div>
                            )}
                            {formCompleteStatus === 1 && (
                                <div className='newUserFormInnerContentHolder'>
                                    <Row>
                                        {!selectedAddress && (
                                            <Column xs={12} margin='0' style={{ position: 'relative' }}>
                                                <AutoComplete
                                                    iconLeft={<Icons icon='person' />}
                                                    label='Start typing your address'
                                                    url='/accountMaster/addresslookup?search={{name}}'
                                                    parser={(d) =>
                                                        d.map((a) => ({ label: a.description, value: a.place_id }))
                                                    }
                                                    onChange={changeAddress}
                                                    placeholder='123 longroad, demoton...'
                                                    className=''
                                                    labelOptions={
                                                        <a
                                                            onClick={() => {
                                                                setSelectedAddress(true)
                                                            }}
                                                        >
                                                            Enter Address Manually
                                                        </a>
                                                    }
                                                    spinnerSize={30}
                                                />
                                            </Column>
                                        )}
                                        {selectedAddress && (
                                            <>
                                                <Column xs={12}>
                                                    <Row>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={i18n.t('company:my.address1')}
                                                                type='text'
                                                                placeholder={i18n.t('company:my.address1')}
                                                                name='address1'
                                                                error={errors.address1}
                                                                value={answers.address1}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={i18n.t('company:my.address2')}
                                                                type='text'
                                                                placeholder={i18n.t('company:my.address2')}
                                                                name='address2'
                                                                error={errors.address2}
                                                                value={answers.address2}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={i18n.t('company:my.address3')}
                                                                type='text'
                                                                placeholder={i18n.t('company:my.address3')}
                                                                name='address3'
                                                                error={errors.address3}
                                                                value={answers.address3}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={i18n.t('company:my.city')}
                                                                type='text'
                                                                placeholder={i18n.t('company:my.city')}
                                                                name='city'
                                                                error={errors.city}
                                                                value={answers.city}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={
                                                                    answers.country === 'United Kingdom'
                                                                        ? i18n.t('company:my.county')
                                                                        : i18n.t('company:my.state')
                                                                }
                                                                type='text'
                                                                placeholder={
                                                                    answers.country === 'United Kingdom'
                                                                        ? i18n.t('company:my.county')
                                                                        : i18n.t('company:my.state')
                                                                }
                                                                name='county'
                                                                error={errors.county}
                                                                value={answers.county}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={6}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <TextInput
                                                                label={
                                                                    answers.country === 'United Kingdom'
                                                                        ? i18n.t('company:my.postCode')
                                                                        : i18n.t('company:my.zip')
                                                                }
                                                                type='text'
                                                                placeholder={
                                                                    answers.country === 'United Kingdom'
                                                                        ? i18n.t('company:my.postCode')
                                                                        : i18n.t('company:my.zip')
                                                                }
                                                                name='postCode'
                                                                error={errors.postCode}
                                                                value={answers.postCode}
                                                                onChange={updateVal}
                                                            />
                                                        </Column>
                                                        <Column
                                                            xs={12}
                                                            sm={12}
                                                            md={12}
                                                            margin='0'
                                                            className='mar-b20'
                                                        >
                                                            <Select
                                                                label={i18n.t('company:my.country')}
                                                                data={countryData}
                                                                placeholder='Select a country'
                                                                name='country'
                                                                error={errors.country}
                                                                value={answers.country}
                                                                onChange={(ev) => {
                                                                    updateVal(ev)
                                                                    setHasVatError(false)
                                                                }}
                                                            />
                                                        </Column>
                                                    </Row>
                                                </Column>
                                                {(isEU || answers.country === 'United Kingdom') && (
                                                    <Column
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        margin='0'
                                                        className='mar-b20'
                                                    >
                                                        <div className='txtInput_label mar-b5'>
                                                            VAT Number <span className='text-grey'>(optional)</span>
                                                        </div>
                                                        <div className='text-xsml text-gray mar-b5'>
                                                            This helps us authenticate your company is genuine, and will
                                                            speed up verification.
                                                        </div>
                                                        <TextInput
                                                            explainer=''
                                                            label={''}
                                                            value={answers.vatNumber}
                                                            name='vatNumber'
                                                            onChange={updateVal}
                                                            error={errors.vatNumber}
                                                            placeholder='VAT Number'
                                                        />
                                                    </Column>
                                                )}
                                                {hasVatError && (
                                                    <Column
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        margin='0'
                                                        className='mar-b20'
                                                    >
                                                        <TextArea
                                                            label='VAT Number is required for EU countries to prove you are a company, if you are not able to provide a VAT number please evidence that you are a valid company (website address, company id etc.)'
                                                            value={answers.noVatReason}
                                                            name='noVatReason'
                                                            onChange={updateVal}
                                                            rows='4'
                                                            error={errors.noVatReason}
                                                        />
                                                    </Column>
                                                )}
                                                <Column xs={12} margin='0'>
                                                    <Button
                                                        className='button-primary'
                                                        iconRight={<Icons icon='arrowRight' />}
                                                        text='Finish'
                                                        onClick={checkFormStep2}
                                                        disabled={checkingStep2}
                                                    />
                                                </Column>
                                            </>
                                        )}
                                    </Row>
                                </div>
                            )}
                            {formCompleteStatus === 2 && approvalTakingTooLong == 0 && (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            flexDirection: 'column',
                                            height: '100%'
                                        }}
                                    >
                                        <div>
                                            <div>
                                                <LoadingIcons
                                                    type='2'
                                                    style={{ height: 30, width: 30 }}
                                                    className='mar-b20'
                                                />
                                            </div>
                                            <h4 className='mar-b5 text-center'>
                                                One moment, we're verifying your details
                                            </h4>
                                            <div className='mar-b15 text-sml text-center text-grey'>
                                                This can take up to 30 seconds. Once verified, you’ll be able to {info}.
                                            </div>
                                        </div>

                                        <Paper
                                            style={{
                                                flex: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                padding: 16
                                            }}
                                            className='mar-b0'
                                        >
                                            <div>
                                                <svg
                                                    width='24'
                                                    height='24'
                                                    viewBox='0 0 24 24'
                                                    fill='none'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        d='M15 14C15.2 13 15.7 12.3 16.5 11.5C17.5 10.6 18 9.3 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 9 6.2 10.2 7.5 11.5C8.2 12.2 8.8 13 9 14'
                                                        stroke='#865FF1'
                                                        stroke-width='1.66667'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M9 18H15'
                                                        stroke='#865FF1'
                                                        stroke-width='1.66667'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M10 22H14'
                                                        stroke='#865FF1'
                                                        stroke-width='1.66667'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                </svg>
                                            </div>
                                            {site?.siteId == 1 && (
                                                <div>
                                                    <div
                                                        style={{
                                                            marginBottom: '4px',
                                                            lineHeight: '20px',
                                                            fontSize: 14,
                                                            fontStyle: 'normal',
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        <strong>
                                                            Did you know {site.siteName} can help manage your social
                                                            posts?
                                                        </strong>
                                                    </div>
                                                    <div
                                                        style={{
                                                            lineHeight: '18px',
                                                            fontSize: 13,
                                                            fontStyle: 'normal',
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        Design, schedule, and post to LinkedIn, X, Facebook, and
                                                        Instagram effortlessly.
                                                    </div>
                                                </div>
                                            )}
                                        </Paper>
                                    </div>
                                </>
                            )}
                            {formCompleteStatus === 2 && approvalTakingTooLong == 1 && (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            flexDirection: 'column',
                                            height: '100%'
                                        }}
                                    >
                                        <div style={{ flex: 0 }}>
                                            <div>
                                                <LoadingIcons
                                                    type='2'
                                                    style={{ height: 30, width: 30 }}
                                                    className='mar-b20'
                                                />
                                            </div>
                                            <h4 className='mar-b10 text-center'>
                                                Hang tight, we're still verifying your details
                                            </h4>
                                            <div className='mar-b10 text-sml text-center text-grey'>
                                                This is taking a little longer than expected, but we're still working on
                                                it.
                                            </div>
                                            <div className='mar-b25 text-sml text-center text-grey'>
                                                You can wait here, or return to {site.siteName}. We'll send an email to{' '}
                                                <strong>{user.userData.emailAddress}</strong> once your approval is
                                                complete.
                                            </div>
                                            <div className='text-center'>
                                                <Button
                                                    className='button-primary mar-b15'
                                                    text={'Back to ' + site.siteName}
                                                    onClick={onFinish}
                                                    iconRight={<Icons icon='arrowRight' />}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ flex: 0 }} className='text-grey text-center text-xsml'>
                                            If you are still awaiting approval after an hour, have any questions, or
                                            require assistance, please contact our{' '}
                                            <a href={'mailto:' + site.supportEmail}>support team</a>.
                                        </div>
                                    </div>
                                </>
                            )}

                            {formCompleteStatus === 3 && (
                                <>
                                    <div className='text-center mar-b10'>
                                        <svg
                                            width='32'
                                            height='32'
                                            viewBox='0 0 32 32'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                d='M29.0681 13.3333C29.6771 16.3217 29.2431 19.4286 27.8386 22.1357C26.4341 24.8429 24.144 26.9867 21.3502 28.2097C18.5563 29.4328 15.4276 29.661 12.4859 28.8565C9.5441 28.0519 6.96705 26.2632 5.1845 23.7885C3.40195 21.3139 2.52163 18.303 2.69035 15.2578C2.85907 12.2127 4.06664 9.31744 6.11167 7.05488C8.1567 4.79232 10.9156 3.29923 13.9282 2.82459C16.9409 2.34995 20.0252 2.92247 22.6668 4.44665'
                                                stroke='#319B90'
                                                stroke-width='2.5'
                                                stroke-linecap='round'
                                                stroke-linejoin='round'
                                            />
                                            <path
                                                d='M12 14.6666L16 18.6666L29.3333 5.33331'
                                                stroke='#319B90'
                                                stroke-width='2.5'
                                                stroke-linecap='round'
                                                stroke-linejoin='round'
                                            />
                                        </svg>
                                    </div>

                                    <h4 className='mar-b5 text-center'>Great News, Your account has been approved!</h4>
                                    <div className='mar-b25 text-center'>
                                        Your account has been approved, you're now ready to start {site.siteName}.
                                    </div>
                                    <div className='text-center'>
                                        <Button
                                            text='Get Started'
                                            onClick={onFinish}
                                            className='button-primary'
                                            iconRight={<Icons icon='arrowRight' />}
                                        />
                                    </div>
                                </>
                            )}

                            {formCompleteStatus === 5 && <MoreQuestions onFinish={() => setFormCompleteStatus(4)} />}

                            {formCompleteStatus === 4 && (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            flexDirection: 'column',
                                            height: '100%'
                                        }}
                                    >
                                        <div style={{ flex: 0 }}>
                                            <div className='text-center mar-b10'>
                                                <svg
                                                    width='32'
                                                    height='32'
                                                    viewBox='0 0 32 32'
                                                    fill='none'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        d='M16 2.66663V7.99996'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M21.5996 10.4L25.4663 6.53333'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M24 16H29.3333'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M21.5996 21.6L25.4663 25.4666'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M16 24V29.3333'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M6.5332 25.4666L10.3999 21.6'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M2.66699 16H8.00033'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                    <path
                                                        d='M6.5332 6.53333L10.3999 10.4'
                                                        stroke='#9B9FA6'
                                                        stroke-width='2.5'
                                                        stroke-linecap='round'
                                                        stroke-linejoin='round'
                                                    />
                                                </svg>
                                            </div>

                                            <h4 className='mar-b15 text-center'>Your account is under review</h4>
                                            <div className='mar-b15 text-center text-grey'>
                                                One of our team will review your account as soon as possible. In the
                                                meantime, you can continue exploring all of {site.siteName}'s incredible
                                                features.
                                            </div>
                                            <div className='mar-b15 text-center text-grey'>
                                                You will receive an email to{' '}
                                                <strong>{user.userData.emailAddress}</strong> when your account is
                                                approved.
                                            </div>
                                            <div className='text-center'>
                                                <Button
                                                    className='button-primary mar-b15'
                                                    text={'Back to ' + site.siteName}
                                                    onClick={onFinish}
                                                    iconRight={<Icons icon='arrowRight' />}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ flex: 0 }} className='text-grey text-center text-xsml'>
                                            If you are still awaiting approval after an hour, have any questions or
                                            require any assistance contact our{' '}
                                            <a href={'mailto:' + site.supportEmail}>support team</a>.
                                        </div>
                                    </div>
                                </>
                            )}

                            {formCompleteStatus === 999 && (
                                <div style={{ padding: '0 50px' }}>
                                    <Row>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={i18n.t('company:my.address1')}
                                                type='text'
                                                placeholder={i18n.t('company:my.address1')}
                                                name='address1'
                                                error={errors.address1}
                                                value={answers.address1}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={i18n.t('company:my.address2')}
                                                type='text'
                                                placeholder={i18n.t('company:my.address2')}
                                                name='address2'
                                                error={errors.address2}
                                                value={answers.address2}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={i18n.t('company:my.address3')}
                                                type='text'
                                                placeholder={i18n.t('company:my.address3')}
                                                name='address3'
                                                error={errors.address3}
                                                value={answers.address3}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={i18n.t('company:my.city')}
                                                type='text'
                                                placeholder={i18n.t('company:my.city')}
                                                name='city'
                                                error={errors.city}
                                                value={answers.city}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={
                                                    answers.country === 'United Kingdom'
                                                        ? i18n.t('company:my.county')
                                                        : i18n.t('company:my.state')
                                                }
                                                type='text'
                                                placeholder={
                                                    answers.country === 'United Kingdom'
                                                        ? i18n.t('company:my.county')
                                                        : i18n.t('company:my.state')
                                                }
                                                name='county'
                                                error={errors.county}
                                                value={answers.county}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={6} margin='0' className='mar-b25'>
                                            <TextInput
                                                label={
                                                    answers.country === 'United Kingdom'
                                                        ? i18n.t('company:my.postCode')
                                                        : i18n.t('company:my.zip')
                                                }
                                                type='text'
                                                placeholder={
                                                    answers.country === 'United Kingdom'
                                                        ? i18n.t('company:my.postCode')
                                                        : i18n.t('company:my.zip')
                                                }
                                                name='postCode'
                                                error={errors.postCode}
                                                value={answers.postCode}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        <Column xs={12} sm={12} md={12} margin='0' className='mar-b25'>
                                            <Select
                                                label={i18n.t('company:my.country')}
                                                data={countryData}
                                                placeholder='Select a country'
                                                name='country'
                                                error={errors.country}
                                                value={answers.country}
                                                onChange={updateVal}
                                            />
                                        </Column>
                                        {(isEU || answers.country === 'United Kingdom') && (
                                            <Column xs={12} sm={12} md={12} margin='0' className='mar-b25'>
                                                <TextInput
                                                    explainer='This helps us authenticate your company is genuine and will speed up verification if entered'
                                                    label='VAT Number'
                                                    value={answers.vatNumber}
                                                    name='vatNumber'
                                                    onChange={updateVal}
                                                    error={errors.vatNumber}
                                                    placeholder='VAT Number'
                                                />
                                            </Column>
                                        )}
                                        {hasVatError && (
                                            <Column xs={12} sm={12} md={12} margin='0' className='mar-b25'>
                                                <TextArea
                                                    label='VAT Number is required for EU countries to prove you are a company, if you are not able to provide a VAT number please evidence that you are a valid company (website address, company id etc.)'
                                                    value={answers.noVatReason}
                                                    name='noVatReason'
                                                    onChange={updateVal}
                                                    rows='4'
                                                    error={errors.noVatReason}
                                                />
                                            </Column>
                                        )}
                                    </Row>
                                    <Button
                                        className='button-primary'
                                        iconRight={<Icons icon='arrowRight' />}
                                        text='Finish'
                                        onClick={checkFormStep2}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
